export default "__VITE_ASSET__Binkn_2P__"